module.exports = __webpack_public_path__ + "static/media/Prothèses_dentaires.9cf48da5.png";